const NotificationsStatusEnum = {
  PENDING: 'PENDING',
  FIXED: 'FIXED',
  DISMISSED: 'DISMISSED',
  OPENED: 'OPENED',
};

export default NotificationsStatusEnum;
